import { EventEmitter, Inject, Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { IconsType } from '../enums/icons.type';
import { NotificationAnimationType } from '../enums/notification-animation-type.enum';
import { NotificationType } from '../enums/notification-type.enum';
import { NotificationEvent } from '../interfaces/notification-event.type';
import { Notification } from '../interfaces/notification.type';

@Injectable({
    providedIn: 'root',
})
export class NotificationsService {
    constructor(
        @Inject('options') public globalOptions: any
    ) {}

    emitter = new Subject<NotificationEvent>();


    set(notification: Notification, to: boolean): Notification {
        notification.id = notification.override && notification.override.id ?
            notification.override.id :
            Math.random().toString(36).substring(3);
        notification.click = new EventEmitter<object>();
        notification.clickIcon = new EventEmitter<object>();
        notification.timeoutEnd = new EventEmitter<object>();


        this.emitter.next({ command: 'set', notification, add: to });
        return notification;
    }

    success(title: any = '', content: any = '', override?: any, context?: any): Notification {
        return this.set({
            title,
            content: content || '',
            type: NotificationType.Success,
            icon: IconsType.success,
            override,
            context
        }, true);
    }

    error(title: any = '', content: any = '', override?: any, context?: any): Notification {
        return this.set({
            title,
            content: content || '',
            type: NotificationType.Error,
            icon: IconsType.error,
            override,
            context
        }, true);
    }

    alert(title: any = '', content: any = '', override?: any, context?: any): Notification {
        return this.set({
            title,
            content: content || '',
            type: NotificationType.Alert,
            icon: IconsType.alert,
            override,
            context
        }, true);
    }

    info(title: any = '', content: any = '', override?: any, context?: any): Notification {
        return this.set({
            title,
            content: content || '',
            type: NotificationType.Info,
            icon: IconsType.info,
            override,
            context
        }, true);
    }

    warn(title: any = '', content: any = '', override?: any, context?: any): Notification {
        return this.set({
            title,
            content: content || '',
            type: NotificationType.Warn,
            icon: IconsType.warn,
            override,
            context
        }, true);
    }

    bootstrap(options: {
        title: string,
        content: string,
        showContentProgressBar: boolean,
        icon: IconsType,
        action?: () => void,
        closeIconAction?: () => void,
        buttonLabel?: string,
        contentProgressBarTime?: number,
        removeAfterOutputAction?: boolean,
        override?: object,
        context?: any
    }): Notification {
        return this.set({
            title: options.title,
            content: options.content,
            type: NotificationType.Bootstrap,
            icon: options.icon,
            override: {
                ...options?.override,
                animate: NotificationAnimationType.FromRight,
            },
            context: options.context,
            outputAction: options?.action,
            closeIconOutputAction: options?.closeIconAction,
            buttonActionLabel: options?.buttonLabel || '',
            removeAfterOutputAction: options?.removeAfterOutputAction,
            showContentProgressBar: options.showContentProgressBar,
        }, true);
    }

    // Remove all notifications method
    remove(id?: string): void {
        if (id) {
            this.emitter.next({ command: 'clean', id });
        } else {
            this.emitter.next({ command: 'cleanAll' });
        }
    }
}
